module.exports = __webpack_public_path__ + "img/logo_finanzas gris.05b62a2c.png";